<div mat-dialog-actions align="end">
    <button mat-icon-button  (click)="onNoClick()">
        <mat-icon>close</mat-icon>
    </button>
    <mat-divider></mat-divider>
</div>

<div mat-dialog-content>

    <kt-filter-statistics  
  
    [selectedFilterId]="data.filter.id"
    [betId] = "data.betId"
    (savedParams)="savedParams($event)"
    [preSelected] = "true"
     >
    </kt-filter-statistics>

</div>

